import { render, staticRenderFns } from "./CreateGoalForm.vue?vue&type=template&id=503a822b&"
import script from "./CreateGoalForm.vue?vue&type=script&lang=js&"
export * from "./CreateGoalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports